import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-displayoption',
  templateUrl: './help-displayoption.component.html'
})
export class HelpDisplayoptionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
